import palette from '../theme/palette';
import colors from '../theme/colors';

const styleOverrides = {
  colorDefault: {
    backgroundColor: palette.common.white,
    borderBottom: `1px solid ${colors.solidGray[200]}`,
  },
};

export default styleOverrides;
